import { ICellRendererParams } from 'ag-grid-community';
import { ChangeEvent, useEffect, useState } from 'react';

import { Input } from 'core/components';
import { isEnterKeyPress } from 'core/utils';

export const AdjustedQuantityCell = ({ value, setValue, data }: ICellRendererParams) => {
  const [quantity, setQuantity] = useState(value ?? '');

  // Controlled so the cell reflects the pre-filled quantity re-seeded from parent state after each
  // fetch/submit (adjustedQuantity in mappedRecords) — a defaultValue input would keep the stale
  // mount value.
  useEffect(() => {
    setQuantity(value ?? '');
  }, [value]);

  // Group header rows (when grouping by UOM) have no data — render blank, not an empty Input.
  if (!data) {
    return null;
  }

  // Keep the raw string in display state (so the field stays typeable — clearing, "1.", trailing
  // zeros), but commit only a parsed number to the grid. The committed value flows untransformed
  // into adjustedQuantity (typed number) and the save payload, so empty/non-numeric must not land.
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    setQuantity(raw);

    if ('' === raw.trim()) {
      return;
    }

    const parsed = Number(raw);
    if (Number.isNaN(parsed)) {
      return;
    }

    setValue(parsed);
  };

  return (
    <Input
      value={quantity}
      onChange={handleOnChange}
      onKeyDown={(event) => (isEnterKeyPress(event) ? event.target.blur() : null)}
    />
  );
};
